<template>
  <div id="app" @load="newMobil()">
    <transition mode="out-in" name="el-fade-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex'
import Throttle from './helper/Throttler'

const applicationStateMappers = createNamespacedHelpers('application')
const tabletsize = 768;
const resizeThrottle = new Throttle(10);

export default {
  name: 'App',
  methods: {
    ...applicationStateMappers.mapMutations([
      'setMobil'
    ]),
  },
  beforeMount() {
    this.setMobil(window.innerWidth < tabletsize);
  },
  mounted() {
    window.addEventListener('resize', () => resizeThrottle.throttle(this.setMobil(window.innerWidth < tabletsize)));
  }
}
</script>

<style lang="scss">
html, body {
  min-height: 100%;
  min-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}

input, textarea {
  caret-color: rgb(6, 105, 177);
}

* {
  font-family: Helvetica, Arial, sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: block;
  position: relative;
  min-height: 100%;
  min-width: 100%;
  height: 100%;
  width: 100%;
}

.el-notification__content {
  text-align: left !important;
}

.right {
  float: right;
}

.subject-input {
  .el-input__inner {
    font-weight: 600;

    &::placeholder {
      color: #606266;
    }
  }
}

.el-range-input,
.el-input__inner {
  &::placeholder {
    color: #606266 !important;
  }
}

.el-picker-panel__link-btn.el-button--default {
  border: 1px solid #409EFF;
  color: #409EFF;
}

.el-picker-panel__link-btn.el-button--text {
  color: #606266;
}

.flip-list-move {
  transition: transform 1s;
}

.edition-information {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
}

.edition-information,
.edition-information-style {
  font-size: 0.8em;
  color: #aaa;
  line-height: normal;
}

.cell {
  word-break: break-word !important;
}

.no-margin-left {
  margin-left: 0 !important;
}
</style>
